module.exports = __webpack_public_path__ + "img/electricidad_02_1280.4e1ab617.jpg";